/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterSessionLengthKind = (typeof FilterSessionLengthKind)[keyof typeof FilterSessionLengthKind];

export const FilterSessionLengthKind = {
  conversation_session_length: 'conversation_session_length',
} as const;
